import { render, staticRenderFns } from "./BarrasAgrupadas.vue?vue&type=template&id=44984a62&scoped=true&"
import script from "./BarrasAgrupadas.vue?vue&type=script&lang=js&"
export * from "./BarrasAgrupadas.vue?vue&type=script&lang=js&"
import style0 from "./BarrasAgrupadas.vue?vue&type=style&index=0&id=44984a62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44984a62",
  null
  
)

export default component.exports